/**
 * @generated SignedSource<<770c9ad79067fe196d20e1c07a092f99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionGuideSectionContentfulRelayFragment$data = {
  readonly collectionStepsCollection: {
    readonly items: ReadonlyArray<{
      readonly relatedTemplate: {
        readonly urlSlug: string | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"templateCardContentfulRelayFragment">;
      } | null | undefined;
      readonly stepDescription: {
        readonly json: any;
      } | null | undefined;
      readonly stepNameExternal: string | null | undefined;
      readonly stepSubheading: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly templateCollectionGuideNameExternal: string | null | undefined;
  readonly " $fragmentType": "collectionGuideSectionContentfulRelayFragment";
};
export type collectionGuideSectionContentfulRelayFragment$key = {
  readonly " $data"?: collectionGuideSectionContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectionGuideSectionContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "collectionGuideSectionContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateCollectionGuideNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CollectionGuideCollectionStepsCollection",
      "kind": "LinkedField",
      "name": "collectionStepsCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TemplateCollectionStep",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stepNameExternal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stepSubheading",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TemplateCollectionStepStepDescription",
              "kind": "LinkedField",
              "name": "stepDescription",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "json",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductTemplate",
              "kind": "LinkedField",
              "name": "relatedTemplate",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urlSlug",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "templateCardContentfulRelayFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CollectionGuide",
  "abstractKey": null
};

(node as any).hash = "1322567ec9bf43ef4ca8dc0fe46bd69f";

export default node;
